import React from "react";
import { IonAlert } from "@ionic/react";
import "./ConfirmationModal.css";

interface ConfirmationModalProps {
  isOpen: boolean;
  header: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  header,
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <IonAlert
      isOpen={isOpen}
      header={header}
      message={message}
      buttons={[
        {
          text: "Cancel",
          role: "cancel",
          handler: onCancel,
        },
        {
          text: "Confirm",
          role: "destructive",
          cssClass: "danger-button",
          handler: onConfirm,
        },
      ]}
      onDidDismiss={onCancel}
    />
  );
};

export default ConfirmationModal;
